import clientRouter from './clientRouter'
import logisticsRouter from './logisticsRouter'
import isLogisticsApp from '../const/isLogisticsApp'

export default isLogisticsApp ? logisticsRouter : clientRouter
